<template>
  <div v-loading="loading" class="nx-page meterenergy-analysis">
    <el-card shadow="never">
      <div slot="header" class="card-head">
        <span>用电量能耗排名（抄表）</span>
        <div class="filters">
          <el-date-picker v-model="billingMonth" type="month" value-format="yyyyMM" clearable size="small" style="width: 150px" />
          <el-button type="primary" size="small" @click="load">查询</el-button>
        </div>
      </div>
      <el-row :gutter="16">
        <el-col :md="14" :xs="24">
          <div ref="chartBar" class="chart-box tall" />
        </el-col>
        <el-col :md="10" :xs="24">
          <el-table :data="ranks" border size="small" style="width: 100%">
            <el-table-column prop="rank" label="名次" width="64" />
            <el-table-column prop="category" label="类目" min-width="120" />
            <el-table-column prop="usageAmount" label="用电量(kWh)" align="right">
              <template slot-scope="{ row }">{{ fmtNum(row.usageAmount) }}</template>
            </el-table-column>
            <el-table-column prop="sharePercent" label="占比" align="right" width="88">
              <template slot-scope="{ row }">{{ row.sharePercent != null ? Number(row.sharePercent).toFixed(2) + '%' : '—' }}</template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { fetchElectricRank } from './api'

export default {
  name: 'MeterEnergyElectricRank',
  data() {
    return { loading: false, billingMonth: null, ranks: [], chart: null }
  },
  mounted() {
    this.load()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    fmtNum(v) {
      if (v == null) return '—'
      return Number(v).toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    resize() {
      if (this.chart) this.chart.resize()
    },
    async load() {
      this.loading = true
      try {
        const res = await fetchElectricRank({ billingMonth: this.billingMonth || undefined })
        const d = (res.data && res.data.data) || {}
        this.ranks = d.ranks || []
        this.$nextTick(() => this.renderBar())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    renderBar() {
      if (this.chart) this.chart.dispose()
      const list = [...this.ranks].reverse()
      this.chart = echarts.init(this.$refs.chartBar)
      this.chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 120, right: 48, top: 16, bottom: 16 },
        xAxis: { type: 'value', name: 'kWh' },
        yAxis: { type: 'category', data: list.map((r) => r.category) },
        series: [{ type: 'bar', data: list.map((r) => Number(r.usageAmount) || 0), itemStyle: { color: '#ea580c' } }]
      })
    }
  }
}
</script>

<style scoped>
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.chart-box.tall {
  height: 420px;
  width: 100%;
}
</style>
